export default {
  primary: {
    color: "background",
    bg: "primary",
    borderRadius: "default",
    "&:hover": {
      bg: "secondary",
      cursor: "pointer",
    },
  },
  ghost: {
    variant: "buttons.primary",
    bg: "rgba(0,0,0,0)",
    border: "thin solid",
    borderColor: "background",
    color: "background",
    "&:hover": {
      bg: "background",
      color: "text",
      cursor: "pointer",
    },
  },
}
